import { Utils } from '../../../../core/helpers/Utils';
import { AbstractTask, PoolParams, TaskParams, PromiseTask, ObserverTask, IsCompleted, PollFunction } from './';
import { Observable, of } from 'rxjs';

export class Pool implements PoolParams {
    readonly queueSize: number = 10;
    readonly poolingInterval: number = 3000;
    readonly maxRetry: number = 60;
    readonly id: string = Utils.id();
    readonly autoDestroy: boolean = true;
    readonly tolerateError: boolean = true;
    readonly startPremierTasksAfterInterval: boolean = true;
    private remainingTasks: AbstractTask[] = [];
    private finishedTasks: AbstractTask[] = [];
    private progressingTasks: AbstractTask[] = [];

    constructor(params: PoolParams) {
        Object.assign(this, params);
    }

    private finishTask(task: AbstractTask) {
        const index: number = this.progressingTasks.indexOf(task);
        if (index >= 0) {
            this.progressingTasks.splice(index, 1);
        }
        this.finishedTasks.push(task);
    }

    private async processTask(task: AbstractTask) {
        this.progressingTasks.push(task);
        let startAfterInterval = this.startPremierTasksAfterInterval && this.finishedTasks.length < this.queueSize;
        try {
            await task.startPolling(this.poolingInterval, this.maxRetry, startAfterInterval);
        } catch (e) {}
        this.finishTask(task);
        console.log('taskFinished');
        await Promise.resolve(); //wait next tick
        this.updateProcessing();
    }

    private updateProcessing() {
        if (!this.remainingTasks.length || this.progressingTasks.length >= this.queueSize) {
            return;
        }
        this.processTask(this.remainingTasks.shift());
    }

    getTasks() {
        return {
            remainingTasks: this.remainingTasks,
            finishedTasks: this.finishedTasks,
            progressingTasks: this.progressingTasks,
        };
    }

    public _addTask(task: AbstractTask): Promise<any> | Observable<any> {
        this.remainingTasks.push(task);
        this.updateProcessing();
        return task instanceof PromiseTask ? (task as PromiseTask).promise : (task as ObserverTask).observer;
    }

    public addTask(pollFunction: PollFunction, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        let params: TaskParams = { pollFunction, isCompleted, tolerateError: this.tolerateError };
        let task = isCompleted ? new PromiseTask(params) : new ObserverTask(params);
        return this._addTask(task);
    }

    public clearTasks() {
        this.remainingTasks = [];
        for (const task of this.progressingTasks) {
            task.cancel();
        }
    }
}
